define("powergen/controllers/admin",
  [],
  function() {
    "use strict";
    var AdminController;

    AdminController = Ember.ObjectController.extend();


    return AdminController;
  });